import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useParticipantsPersonApi } from '@/features/api/hooks/participant/useParticipantsPersonApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

export const useGetPerson = () => {
  const { isAuthenticated } = useAuth();
  const api = useParticipantsPersonApi();

  return useQuery({
    queryKey: [API_CACHE_KEYS.PERSON],
    queryFn: () => api.getPerson(),
    enabled: isAuthenticated
  });
};
